import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import RoomItemForm from '../../components/MangeHKT/RoomItemForm'

function EditRoomItem() {
    const navigate = useNavigate()
    const {id} = useParams()
    const selectedProperty = JSON.parse(localStorage.getItem('selectedProperty')) || {}
    const manage_hkt_data = JSON.parse(localStorage.getItem('edit-manage-hkt')) || {}
    const [roomItems, setRoomItems] = useState()
    // handleGoBack
    const handleGoBack = () => {
        navigate(-1)
    }
    
    // create action
    const handleForm = async (propsData) => {
        console.log(propsData)
        const { property, roomItemDescription,roomItemName,roomItemType, status } = propsData
        if (propsData) {
            const data = {
                ri_id: Number(id),
                roomitemtypes_id: roomItemType,
                properties_id: property,
                item_name: roomItemName,
                item_description: roomItemDescription,
                status: status || "active",
            };
            try {
                const response = await nbrApi.post('/updateroomitem', data, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Room Item Updated Successful',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack();
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error.message)
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Room Item Update failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Room Item Updated Failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    useEffect(() => {
        if(id){
            const getData = async () => {
                try {
                    const response = await nbrApi.get(`/getroomitemsbyrity?properties_id=${selectedProperty.value}&rity_id=${manage_hkt_data?.rity_id}`);

                    const data = response.data;
                    setRoomItems(data?.map(e => ({
                        ...e,
                        value: e?.ri_id,
                        label: e?.item_name
                    })));
        
                } catch (error) {
                    console.error('Error fetching data:', error.message);
                }
            }

            getData()
        }
    },[id])

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Edit Room Item</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'><i className='fa fa-undo' /> Go Back</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <RoomItemForm handleAction={handleForm} roomItemsData={roomItems} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditRoomItem